import { Box, TextField } from '@tradersclub/core-ui';

import useRouterStore from 'hooks/useRouter';
import { getUTMHubspotByRouterQuery } from 'utils/utils';

const FieldsTrackHubspot = () => {
  const { router } = useRouterStore();

  return (
    <Box display="none">
      {getUTMHubspotByRouterQuery(router.query).map((field) => (
        <TextField key={field.name} type="text" name={field.name} value={field.value} />
      ))}
    </Box>
  );
};

export default FieldsTrackHubspot;
